import moment from 'moment'

export default {
  methods: {
    getTitleEvent(event) {
      return `${event.type?.title} (${moment(event.time_start).format('HH:MM')}-${moment(event.time_finish).format(
        'HH:MM DD.MM.YYYY'
      )})`
    }
  },
  computed: {
    colorBadgeTypeEvent() {
      switch (this.event?.type?.alias) {
        case 'presentation':
          return {
            bg: 'rgba(222, 135, 3, 0.1);',
            text: '#DE8703',
          }
        case 'lecture':
          return {
            bg: 'rgba(0, 56, 130, 0.1);',
            text: '#003882',
          }
        case 'discussion':
          return {
            bg: 'rgba(195, 67, 67, 0.1);',
            text: '#C34343',
          }
        case 'qa':
          return {
            bg: 'rgba(0, 166, 227, 0.1);',
            text: '#00A6E3',
          }
        case 'workshop':
          return {
            bg: 'rgba(40, 173, 132, 0.1);',
            text: '#28AD84',
          }
      }

      return {}
    },
  },
}
